import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getOperators = () => async (dispatch) => {
    dispatch({
        type: 'OPERATORS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/operator/getall/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'OPERATOR_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'OPERATOR_NOT_LOADING'
        })
    }
}

export const getActiveOperators = () => async (dispatch) => {
    dispatch({
        type: 'OPERATOR_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/operator/getactive/', {}, {
            headers: { auth: localStorage.getItem('jwt') },
        })
        if (status === 200) {
            dispatch({
                type: 'OPERATOR_GETACTIVE_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'OPERATOR_NOT_LOADING'
        })
    }
}

export const getOperator = (operator) => async (dispatch) => {
    dispatch({
        type: 'OPERATOR_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/operator/get/'+ operator, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'OPERATOR_GET_SUCCESS',
                payload: data.operator
            })
        }
    } catch (error) {
        dispatch({
            type: 'OPERATOR_NOT_LOADING'
        })
    }
}

export const addOperator = (operatordata) => async (dispatch) => {
    dispatch({
        type: 'OPERATOR_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/operator/register', operatordata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'OPERATOR_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'OPERATOR_NOT_LOADING'
        })
    }
}

export const editOperator = (operatordata, idOperator) => async (dispatch) => {
    try {
        const { data, status} = await Axios.put('/api/operator/edit/' + idOperator, operatordata, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'OPERATOR_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'OPERATOR_ERROR'
        })
    }
}

export const removeOperator = (operator) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/operator/remove/' + operator, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        })
        if (status === 200 || status === 263 || status === 261) {
            dispatch({
                type: 'OPERATOR_REMOVE_RESULT',
                payload: {...data, status}
            })
        }
    } catch (error) {
        dispatch({
            type: 'OPERATOR_NOT_LOADING'
        })
    }
}

export const resetOperator = () => async (dispatch) => {
    dispatch({
        type: 'OPERATORS_RESET'
    })
}

export const enableOperator = (idOperator) => async (dispatch) => {
    dispatch({
        type: 'OPERATOR_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/operator/enable/' + idOperator, {}, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'OPERATOR_ENABLEDISABLE_SUCCESS',
                payload: {...data, idOperator: idOperator}
            })
        }
    } catch (error) {
        dispatch({
            type: 'OPERATOR_ERROR'
        })
    }
}

export const disableOperator = (idOperator) => async (dispatch) => {
    dispatch({
        type: 'OPERATOR_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/operator/disable/' + idOperator, {}, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 263 || status === 260) {
            dispatch({
                type: 'OPERATOR_ENABLEDISABLE_SUCCESS',
                payload: {...data, idOperator: idOperator}
            })
        }
    } catch (error) {
        dispatch({
            type: 'OPERATOR_ERROR'
        })
    }
}